import { VHeaders } from '@/models/pagedlistmodel';

export function getDealSearchHeader(vm: any): VHeaders[] {
  return [
    {
      text: '',
      value: 'selected',
      align: 'left',
      sortable: false,
      fieldType: 'checkbox',
      header: {
        type: 'checkbox',
      },
    },
    {
      text: vm.$parent.$t(
        'dealList.dealSearchDialog.dealSearchHeader.stockNumber'
      ) as string,
      align: 'left',
      value: 'stockNumber',
      sortable: true,
    },
    {
      text: vm.$parent.$t(
        'dealList.dealSearchDialog.dealSearchHeader.dealNumber'
      ) as string,
      align: 'left',
      value: 'dealNumber',
      sortable: true,
    },
    {
      text: vm.$parent.$t(
        'dealList.dealSearchDialog.dealSearchHeader.make'
      ) as string,
      align: 'left',
      value: 'make',
      sortable: true,
    },
    {
      text: vm.$parent.$t(
        'dealList.dealSearchDialog.dealSearchHeader.model'
      ) as string,
      align: 'left',
      value: 'model',
      sortable: true,
    },
    {
      text: vm.$parent.$t(
        'dealList.dealSearchDialog.dealSearchHeader.modelYear'
      ) as string,
      align: 'left',
      value: 'modelYear',
      sortable: true,
    },
  ];
}

export function getDealHeader(vm: any): VHeaders[] {
  return [
    {
      text: '',
      value: 'selected',
      align: 'left',
      sortable: false,
      fieldType: 'checkbox',
      header: {
        type: 'checkbox',
      },
    },
    {
      text: vm.$parent.$t('dealList.gridHeaders.dealNumber') as string,
      value: 'dealNumber',
      align: 'left',
      sortable: true,
    },
    {
      text: vm.$parent.$t('dealList.gridHeaders.stockNumber') as string,
      align: 'left',
      value: 'stockNumber',
      sortable: true,
    },
    {
      text: vm.$parent.$t('dealList.gridHeaders.saleType') as string,
      align: 'center',
      value: 'recordType',
      sortable: false,
    },
    {
      text: vm.$parent.$t('dealList.gridHeaders.buyerName') as string,
      align: 'left',
      value: 'customerName',
      sortable: true,
    },
    {
      text: vm.$parent.$t('dealList.gridHeaders.dealDate') as string,
      value: 'dealDate',
      align: 'left',
      sortable: true,
      fieldType: 'date',
      format: 'L',
    },
    {
      text: vm.$parent.$t('dealList.gridHeaders.year') as string,
      value: 'modelYear',
      align: 'left',
      sortable: false,
    },
    {
      text: vm.$parent.$t('dealList.gridHeaders.make') as string,
      value: 'make',
      align: 'left',
      sortable: false,
    },
    {
      text: vm.$parent.$t('dealList.gridHeaders.model') as string,
      value: 'model',
      align: 'left',
      sortable: false,
    },
    {
      text: vm.$parent.$t('dealList.gridHeaders.salesPerson') as string,
      value: 'salesPerson',
      align: 'left',
      sortable: true,
      filters: [
        (val) => {
          return val && val !== 'N/A' ? val : ' ';
        },
      ],
    },
    {
      text: vm.$parent.$t('dealList.gridHeaders.financePerson') as string,
      value: 'financePerson',
      align: 'left',
      sortable: true,
      filters: [
        (val) => {
          return val && val !== 'N/A' ? val : ' ';
        },
      ],
    },
    {
      text: 'Salty Status',
      value: 'saltErrorResponse',
      align: 'left',
      sortable: false,
      filters: [
        (val) => {
          return val && val !== 'N/A' ? val : ' ';
        },
      ],
    },
    {
      text: vm.$parent.$t('dealList.gridHeaders.actions') as string,
      align: 'center',
      value: 'action',
      isNotDataProp: true,
      sortable: false,
    },
  ];
}
export function getShipmentDealHeaders(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t('dealShipment.gridHeaders.stockNumber') as string,
      align: 'left',
      value: 'stockNumber',
    },
    {
      text: vm.$parent.$t('dealShipment.gridHeaders.buyerName') as string,
      align: 'left',
      value: 'customerName',
    },
    {
      text: vm.$parent.$t('dealShipment.gridHeaders.date') as string,
      align: 'left',
      value: 'dealDate',
      fieldType: 'date',
      format: 'L',
    },
    {
      text: vm.$parent.$t('dealShipment.gridHeaders.dealNumber') as string,
      value: 'dealNumber',
      align: 'left',
    },
    {
      text: vm.$parent.$t('dealShipment.gridHeaders.salesPerson') as string,
      value: 'salesPerson',
      align: 'left',
      sortable: true,
    },
    {
      text: vm.$parent.$t('dealShipment.gridHeaders.financePerson') as string,
      value: 'financePerson',
      align: 'left',
      sortable: true,
    },
  ];
}
export function getTrackingInfoHeaders(vm: any): VHeaders[] {
  return [
        {
          align: 'left',
          sortable: true,
          text: vm.$parent.$t(
            'dealTracking.gridHeaders.trackingNumber'
          ) as string,
          value: 'trackingId',
        },
        {
          align: 'left',
          sortable: true,
          text: vm.$parent.$t('dealTracking.gridHeaders.description') as string,
          value: 'description',
        },
        {
          align: 'left',
          text: vm.$parent.$t('dealTracking.gridHeaders.createdAt') as string,
          value: 'createdAt',
          fieldType: 'date',
        },
        {
          align: 'left',
          sortable: true,
          text: vm.$parent.$t('dealTracking.gridHeaders.createdBy') as string,
          value: 'createdBy',
        },
        {
          align: 'center',
          isNotDataProp: true,
          text: vm.$parent.$t('dealTracking.gridHeaders.actions') as string,
          sortable: false,
        },
      ];
}

export function getDealLeaseInfoHeaders(vm: any): VHeaders[] {
  return [
        {
          align: 'left',
          sortable: true,
          text: 'Sale',
          value: 'sale',
        },
        {
          align: 'left',
          sortable: true,
          text: 'Cost',
          value: 'cost',
        },
        {
          align: 'left',
          sortable: true,
          text: 'Gross',
          value: 'gross',
        },
        {
          align: 'left',
          sortable: true,
          text: 'Description',
          value: 'description',
        },
      ];

}

export function getDealTradeInfoHeaders(vm: any): VHeaders[] {
  return [
        {
          align: 'left',
          sortable: true,
          text: 'StockNumber',
          value: 'stockNumber',
        },
        {
          align: 'left',
          sortable: true,
          text: 'Year',
          value: 'tradeYear',
        },
        {
          align: 'left',
          sortable: true,
          text: 'Make',
          value: 'tradeMake',
        },
        {
          align: 'left',
          sortable: true,
          text: 'Model',
          value: 'tradeVin',
        },
        {
          align: 'left',
          sortable: true,
          text: 'Model',
          value: 'tradeAllowance',
        },
        {
          align: 'left',
          sortable: true,
          text: 'ACV',
          value: 'tradeAcv',
        },
      ];

}
